import React from 'react';
import logo from "../../common/media/cc-logo-black.svg";

import { getMerchantCodeWithPrefix } from '../../../tools/MyCCMerchantLinkGenerator';

const ExtraTips = (props) => {
    return (
        <div className="py-4 bg-primary mobile-p-1">
            <div className="container">
                <div className="mw-720px p-3 center">
                    <h3 className="font-bold">Feeling inspired to do more?</h3>
                    <p className="font-bold">{`Take action on your personal environmental impact by supporting the worlds best projects that fight climate change.`}</p>
                    <a target="_blank" className="btn btn-secondary btn-lg" href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(props.merchantCode)}/subscribe`}>See personal plans</a>
                </div>
                <div className="bg-primary pt-1 text-center">
                    <div className="d-flex w-fit center">
                        <h6 className="mr-2 mt-1 mb-0">Powered By</h6>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 25 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExtraTips;